import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { OnboardingForm } from '../components/features/onboarding/OnboardingForm';
import toast from 'react-hot-toast';

interface TokenValidationResponse {
  data: {
    email: string;
    brandId: string;
    offerId: string;
    token: string;
    brand: {
      id: string;
      name: string;
      logo?: string;
    };
  };
}

export function OnboardingPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [validationData, setValidationData] = useState<TokenValidationResponse['data'] | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      try {
        if (!token) {
          throw new Error('Token is required');
        }
        const response = await fetch(`/api/public/onboarding/${token}/validate`);
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.error?.error || 'Failed to validate token');
        }
        const data: TokenValidationResponse = await response.json();
        setValidationData({
          ...data.data,
          token
        });
      } catch (error) {
        console.error('Token validation error:', error);
        toast.error(error instanceof Error ? error.message : 'Invalid or expired token');
        navigate('/');
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      validateToken();
    }
  }, [token, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#7B1C14] flex items-center justify-center">
        <div className="text-[#F7E8CC] text-xl">Loading...</div>
      </div>
    );
  }

  if (!validationData) {
    return null; // Navigate would have been called
  }

  return <OnboardingForm initialData={validationData} />;
} 